module.exports = __webpack_public_path__ + "static/media/total.d1dd5395.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Chess/RightMenu/About/total.svg
// module id = 1619
// module chunks = 0